<template>
  <details-header :loading="loading">
    <template v-slot:avatar>
      <avatar :avatarUrl="coreValue.badgeUrl" :size="100"></avatar
    ></template>
    <template v-slot:headerLine1>
      {{ coreValue.name }}
    </template>
    <template v-slot:headerLine2 v-if="coreValue.id">
      Created On {{ coreValue.createdDate | longDate }}
    </template>
    <v-row>
      <v-col cols="12" v-if="settings.coreValues.length == 0">
        <ad-header-card
          title="Manage core value & add example behaviors 👌"
          subtitle="Level up your core values by adding example behaviors. This info will be used as helper text within the culture tracking core value questions."
        >
          <template v-slot:helpText>
            <div @click="goBack" class="cursor-pointer">
              <v-icon color="accent" small>keyboard_arrow_left</v-icon>
              Go back
            </div>
          </template>
        </ad-header-card>
      </v-col>
      <v-col cols="12">
        <core-value-form v-on:save="saveCoreValue"></core-value-form>
      </v-col>
    </v-row>
  </details-header>
</template>

<script>
import { mapGetters } from "vuex";
import CoreValueForm from "@/components/company/CoreValueForm";
import DetailsHeader from "@/components/common/DetailsHeader";
import AdHeaderCard from "@/components/common/AdHeaderCard";
export default {
  name: "CoreValueDetails",
  components: {
    "core-value-form": CoreValueForm,
    "details-header": DetailsHeader,
    AdHeaderCard
  },
  data: () => ({
    loading: false
  }),
  watch: {},
  computed: {
    coreValueId() {
      return this.$route.params.id;
    },
    ...mapGetters({
      coreValue: "company/edit_corevalue",
      settings: "profile/settings"
    })
  },
  created() {
    this.loading = true;
    Promise.all([
      this.$store.dispatch("company/getCoreValue", this.coreValueId)
    ])
      .catch(error => {
        this.logError(error);
        this.$root
          .$alert("Error Occurred", "An error occured while loading")
          .then(() => {
            this.$router.push({ path: "/company" });
          });
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    saveCoreValue() {
      if (this.$route.query.returnUrl) {
        this.$router.push({ path: this.$route.query.returnUrl });
      } else {
        this.goBack();
      }
    },
    goBack() {
      this.$router.push({ path: "/company" });
    }
  }
};
</script>
